import { render, staticRenderFns } from "./showdata.vue?vue&type=template&id=16a9c4bf&"
import script from "./showdata.vue?vue&type=script&lang=js&"
export * from "./showdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports